



import { defineComponent, onMounted } from '@vue/composition-api';
// @ts-ignore
import { jumpOneLink, getKpn, getTargetUrl, getOnelink } from '@common/util';
// @ts-ignore
import { defaultOneLink } from '@common/const';
// @ts-ignore
import { radarLog, getKwaiLog, getShareCommonParams, immediateSendLog } from '@common/log';
import Page from './components/page/index.vue';

export default defineComponent({
    components: {
        Page,
    },
    setup(props, { root }: any) {
        const fmp_time = Date.now();
        const {
            initData: { query, userData, kpn: k, ABConfig, shareUserInfo, did },
            message: { metaConfig, onelink },
        } = root.$store.state;

        const userId = userData?.profile?.user_id;

        const handleOpenKwai = (clickSource: any = 'follow') => {
            // oneLink
            const { host, href, pathname } = window.location;
            const kpn = k || getKpn(host, (query?.kpn || '') as string);
            const onelinkList = onelink || {};

            let deepLinkQueryStr = '';
            if (ABConfig?.shareGpUserFeedBackAb === 'ikwai_link'){
                deepLinkQueryStr = `&deep_link_value=${encodeURIComponent(`ikwai://profile/${userId}`)}`;
            }
            const oneLinkUrlBase = Object.keys(onelinkList).includes(kpn) ? onelinkList[kpn] : defaultOneLink;
            const oneLinkUrl = `${oneLinkUrlBase}?pid=H5${deepLinkQueryStr}&c=profile&af_channel=share`;

            jumpOneLink(
                getOnelink(oneLinkUrl, clickSource),
                null,
                `profile/${userId}?target_url=${getTargetUrl(href, clickSource, {
                    metaGroupId: metaConfig?.groupId,
                    groupId: ABConfig?.groupId,
                })}`
            );

            radarLog({
                name: 'PROFILE_H5_CLICK_COUNT',
                event_type: 'click',
                category: 'KWAI_SHARE',
                message: `点击${clickSource}的次数`,
                src: pathname,
            });
        };

        const eventTracking = () => {
            try {
                const webLogger = getKwaiLog();
                webLogger?.plugins?.radar && webLogger.plugins.radar.fmp(fmp_time);

                // 新版UI增加的埋点
                const pageType = {
                    1: 'NORMAL',
                    1016001004: 'REGION_SHIELD',
                    1016001016: 'REGION_SHIELD',
                };

                const shareLogPara: any = getShareCommonParams(query, 'PROFILE_H5');
                if (window.location.pathname?.includes('/one/features/share')) {
                    shareLogPara.share_item_type = 'profile';
                    shareLogPara.share_item_info = userData?.profile?.user_id;
                    shareLogPara.share_device_id = did;
                }

                shareLogPara.group_id = ABConfig?.groupId;
                shareLogPara.page_type = pageType[shareUserInfo?.result] || 'NORMAL';

                immediateSendLog({
                    type: 'pv',
                    name: 'PROFILE_H5',
                    value: {
                        author_id: userId,
                        share_channel: query.cc || 'default',
                        url: window.location.href,
                        ...shareLogPara,
                    },
                });

                radarLog({
                    name: 'PROFILE_H5',
                    event_type: 'pv',
                    category: 'KWAI_SHARE',
                    message: 'PROFILE_H5的pv',
                    src: window.location.pathname,
                });
            } catch (error) {
                console.error(error);
            }
        };

        onMounted(() => {
            eventTracking();
        });
        return {
            handleOpenKwai,
        };
    },
});
